export const getUserPermissions = (modules) => {
    const selectedModules = modules
        .filter((mod) => mod.isSelected)
        .map((mod) => ({
            ...mod,
            submodules: mod.submodules.filter((sub) => sub.isSelected),
        }))
        .filter((mod) => mod.submodules.length > 0);

    const cleanedPermissions = selectedModules.map((module) => {
        const { isSelected, submodules, ...moduleData } = module;

        const cleanedSubmodules = submodules.map((submodule) => {
            const { isSelected, ...submoduleData } = submodule;
            return submoduleData;
        });

        return { ...moduleData, submodules: cleanedSubmodules };
    });

    return cleanedPermissions

};